import axios from "axios";
import { BASE_URL } from "../../../Helper/Helper";

const GlobalTemplateState = {
  addGlobalTemplate: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/create-global-template`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    return datas;
  },

  getGlobalTemplate: async () => {
    // FETCH API CALL For all notes
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/get-all-global-template`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data.data;
    return datas;
  },

  getGlobalTemplateByTab: async (tab) => {
    // FETCH API CALL For all notes
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/get-global-template/${tab}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    //console.log("response", response);
    let datas = response.data.data;
    //console.log("datas", datas);
    return datas;
  },

  deleteGlobalTemplate: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.delete(
      `${BASE_URL}/api/v2/admin/delete-global-template/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    return datas;
  },

  updateGlobalTemplate: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.put(
      `${BASE_URL}/api/v2/admin/update-global-template/${id}`,
      requestOptions
    );

    let datas = response.data;
    return datas;
  },
};

export default GlobalTemplateState;
